"use client";

import { Download } from "lucide-react";
import { Button } from "../ui/button";
import { Dialog, DialogTrigger } from "../ui/dialog";
import DownloadDialog from "../DownloadDialog";

interface RegisterDownloadButtonProps {
  className?: string;
}

export default function RegisterDownloadButton({
  className,
}: RegisterDownloadButtonProps) {
  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button variant="downloadOutline" className={className}>
          <Download className="mr-2" aria-hidden="true" /> Download Stone
        </Button>
      </DialogTrigger>
      <DownloadDialog />
    </Dialog>
  );
}
